import { useEffect, useState } from 'react';

export function useScrollEndReached(
    container: HTMLElement | null,
    ...contentVersions: unknown[]
): boolean {
    const [endReached, setEndReached] = useState(true);

    useEffect(() => {
        if (!container) {
            setEndReached(true);
            return;
        }

        const update = () => {
            setEndReached(
                container.scrollTop + container.clientHeight >=
                    container.scrollHeight - 1,
            );
        };

        update();

        container.addEventListener('scroll', update, { passive: true });
        const resizeObserver = new ResizeObserver(update);
        resizeObserver.observe(container);
        if (container.firstElementChild) {
            resizeObserver.observe(container.firstElementChild);
        }

        return () => {
            container.removeEventListener('scroll', update);
            resizeObserver.disconnect();
        };
    }, [container, ...contentVersions]);

    return endReached;
}
